import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { I18N } from 'aurelia-i18n';
import { NotificationClientService } from '../../../services/basics/notification-client.service';
import { NotifyPropertyChangedBase } from '../../../utilities/reflection';

export abstract class ChildComponent<TEntity> extends NotifyPropertyChangedBase {

    public resetAfterSubmit: boolean = true;

    private _item: TEntity;

    public get item(): TEntity {
        return this._item;
    }

    public set item(x: TEntity) {
        this._item = x;
        this.onItemChanged();
    }

    constructor(protected notificationService: NotificationClientService, protected i18N: I18N) {
        super();
    }

    public activate(model: any) {
        this.item = typeof (model) == "string" ? this.parse(<string>model) : model;
        this.onActivated(this.item);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected onActivated(model: TEntity) { }

    private parse(obj: string): TEntity {
        return JSON.parse(obj.replace(new RegExp("&quot;", "g"), "\"")
            .replace(new RegExp("&gt;", "g"), ">")
            .replace(new RegExp("&lt;", "g"), "<"));
    }

    public get entityType(): EntityTypes {
        if (this.item) {
            return this.item["entityType"];
        }
    }

    protected onItemChanged() {

    }
}
